import { createSelector } from 'reselect'
import { convertData2JsonForm } from '../../../../shared/lib/convertData2JsonForm'

export const createSession = createSelector(
  (state: any) => state.session,
  sessionData => sessionData,
)
const selectClaimWork = state => state.claimWork

export const getDataLoading = createSelector(selectClaimWork, ({ form }) => form?.isLoading)

export const getCardData = createSelector(selectClaimWork, ({ form }) => form)

export const getCardStages = createSelector(selectClaimWork, ({ stages }) => stages)

export const getCardCurrentStage = createSelector(getCardStages, ({ current }) => current)

export const getFormData = createSelector(selectClaimWork, ({ form }) => form)

export const getCardError = createSelector(getFormData, ({ error }) => error)

export const getParentId = createSelector(selectClaimWork, ({ parent_id }) => parent_id)

export const getVisibleFormData = createSelector([getFormData], formData => {
  if (formData) {
    const { data: form } = formData
    if (!form) {
      return undefined
    }
    const { resultObject, resultSchema } = convertData2JsonForm(form)
    return { resultSchema, resultObject }
  }
})
